import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["paymentMethodType", "recurring", "pledge", "oneTime"];

  paymentMethodTypeTargetConnected() {
    this.togglePaymentMethod();
  }

  togglePaymentMethod() {
    if (this.paymentMethodTypeTarget.value === "bitcoin") {
      this.oneTimeTarget.click()
      this.toggleDisabled([this.recurringTarget, this.pledgeTarget], true);
    } else {
      this.toggleDisabled([this.recurringTarget, this.pledgeTarget], false);
    }
  }

  toggleDisabled(targets, disabled) {
    targets.forEach(target => {
      target.disabled = disabled;
      target.closest("label").classList.toggle("disabled", disabled);
    });
  }
}
